import styles from './index.module.css';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import {
  MostScheduledJobsDocument,
  MostScheduledJobsQuery,
} from 'src/graphql/generated/graphql';
import React from 'react';
import { Chip, ElementsGroup } from '@otp/ui';

interface DuplicateConfigAlertProps {
  commandId: string;
  devices: string[];
}

export const DuplicateConfigAlert = ({
  commandId,
  devices,
}: DuplicateConfigAlertProps) => {
  const { t } = useTranslation();

  const { loading, data, previousData } = useQuery<MostScheduledJobsQuery>(
    MostScheduledJobsDocument,
    {
      variables: {
        filter: {
          commandId,
          devices,
        },
        pagination: {
          limit: 10,
          offset: 0,
        },
      },
      skip: !commandId || !devices?.length,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    },
  );

  const duplicatedConfigs =
    data !== undefined
      ? data?.mostScheduledJobs?.records
      : previousData?.mostScheduledJobs?.records;

  if (!duplicatedConfigs?.length) {
    return null;
  }

  const devicesScheduled = duplicatedConfigs?.map(
    (config) => config.jobConfig?.devices,
  );
  const devicesScheduledFlat = devicesScheduled?.flat();
  const alreadyScheduledDevicesFromForm = devices?.filter((device) =>
    devicesScheduledFlat.includes(device),
  );

  return (
    <div className={styles.root}>
      {t('most.list.schedule.form.duplicated-config')}{' '}
      <ElementsGroup
        elements={alreadyScheduledDevicesFromForm.map((device) => (
          <Chip key={device} label={device} />
        ))}
        limit={3}
      />
    </div>
  );
};
